import { IndustriesStateType } from "../types/app";

type RoleStateType = {
  roleId: string;
  roleName: string;
};

interface SubSegmentObject {
  subSegmentId: string;
}

interface IndustryListForAnalytics {
  [key: string]: string;
}

export const matchObjectsByID = (
  arrayOfStrings: string[],
  arrayOfObjects: SubSegmentObject[]
): SubSegmentObject[] =>
  arrayOfObjects.filter((obj) => arrayOfStrings.includes(obj.subSegmentId));

export const filteredArray = (arr: Array<any>, properties: Array<any> = []) => {
  return arr.map((item) => {
    let newItem = { ...item };
    properties.forEach((property) => {
      delete newItem[property];
    });
    return newItem;
  });
};

export const getSelectedRole = (
  arr: RoleStateType[],
  selectedId?: string,
  selectedName?: string
) => {
  let result;
  if (selectedId) {
    result = arr.find((item) => selectedId === item.roleId);
  } else if (selectedName) {
    result = arr.find((item) => selectedName === item.roleName);
  }

  return result ? result : { roleId: '', roleName: '' };
};

export const selectedIndustryIds = (arrayOfObjects: Array<any>) => {
  return arrayOfObjects.map((obj) => obj.subSegmentId);
};

export const selectedIndustryNames = (arrayOfObject: Array<any>) => {
  return arrayOfObject.map((obj) => obj.subSegmentName)
};

export const matchArraysByItem = (array1: String[], array2: String[]) => {
  if (array1.length !== array2.length) return false;

  const onlyInArr1 = array1.filter((value) => !array2.includes(value));
  const onlyInArr2 = array2.filter((value) => !array1.includes(value));
  if (onlyInArr1.length !== 0 || onlyInArr2.length !== 0) return false;

  return true;
}

export const getIndustryListForAnalytics = (industries: IndustriesStateType[]) => {
  // This method will return the updated industry list for adp analytics
  if (!industries || industries.length === 0) {
    return {};
  }

  const updIndustryObj: IndustryListForAnalytics = {};
  industries.forEach((industry: IndustriesStateType) => {
    const subSegmentId = industry.subSegmentId || '';
    updIndustryObj[subSegmentId] = industry.subSegmentName || '';
  });

  return updIndustryObj;
}